import { FC } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

type Props = {
  label: string;
  value: string;
};

const styles = StyleSheet.create({
  label: {
    // former "caption"
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 10,
    lineHeight: 1.42,
    letterSpacing: 1,
    textTransform: "uppercase",
    color: "#666A84",
    marginBottom: 4,
  },
  value: {
    // former "text"
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: 1.5,
    color: "#1A2147",
  },
});

export const Field: FC<Props> = ({ label, value }) => {
  return (
    <View>
      <Text style={styles.label}>{label}</Text>
      <Text style={styles.value}>{value}</Text>
    </View>
  );
};
